import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const assetsObjectTypeConfigurationRoute: InvariantJiraRoute = {
	name: 'assets-object-type-configuration',
	path: '/jira/assets/configure/object-type/:objectTypeId',
};
